import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth, formatApiError } from "../auth/AuthContext";
import GoogleAuthButton from "../components/GoogleAuthButton";
import PhoneOtpField from "../components/PhoneOtpField";
import { AuthCheckbox } from "../components/AuthCheckbox";

export default function Register() {
  const { user, register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "buyer", company: "", phone: "" });
  const [err, setErr] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [busy, setBusy] = useState(false);
  const [phoneToken, setPhoneToken] = useState("");

  if (user && user !== false) return <Navigate to="/workspace" replace />;

  const set = e => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async e => {
    e.preventDefault();
    if (!phoneToken) { setErr("Please verify your mobile number with OTP."); return; }
    setBusy(true); setErr("");
    try {
      await register({ ...form, email: form.email.trim().toLowerCase(), phone_token: phoneToken });
      nav("/workspace", { replace: true });
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell" data-testid="register-page">
      <div className="auth-card wide">
        <Link to="/" className="auth-brand" data-testid="auth-brand-link">
          <img src="/logo.png" alt="GoPrintPack" className="auth-logo"/>
        </Link>
        <h1>Create your account</h1>
        <p className="auth-sub">Join GoPrintPack™ as a buyer sourcing print/packaging, a printer bidding on sealed auctions, or a design agency serving clients.</p>

        <GoogleAuthButton label="Sign up with Google" testId="register-google-btn" />
        <div className="auth-divider" data-testid="auth-divider"><span>or continue with email</span></div>

        <form onSubmit={submit} className="auth-form grid">
          <label>I am a
            <select data-testid="reg-role" name="role" value={form.role} onChange={set}>
              <option value="buyer">Buyer — I need print/packaging</option>
              <option value="printer">Printer / Supplier</option>
              <option value="agency">Design agency / Studio</option>
              <option value="material_supplier">Material supplier (paper, board, ink…)</option>
              <option value="finishing_partner">Finishing partner (lamination, foiling…)</option>
            </select>
          </label>
          <label>Full name
            <input data-testid="reg-name" name="name" value={form.name} onChange={set} required minLength={2}/>
          </label>
          <label>Company (optional)
            <input data-testid="reg-company" name="company" value={form.company} onChange={set}/>
          </label>
          <label>Email
            <input data-testid="reg-email" type="email" name="email" value={form.email} onChange={set} required autoComplete="email"/>
          </label>
          <label>Password
            <input data-testid="reg-password" type={showPw ? "text" : "password"} name="password" value={form.password} onChange={set} required minLength={6} autoComplete="new-password"/>
          </label>
          <AuthCheckbox className="span-2" testid="reg-show-password" checked={showPw} onChange={setShowPw} label="Show password"/>
          <PhoneOtpField className="span-2" testIdPrefix="reg-otp" phone={form.phone}
            setPhone={(v) => setForm((f) => ({ ...f, phone: v }))} token={phoneToken} setToken={setPhoneToken} email={form.email} />
          {err && <div className="auth-error span-2" data-testid="register-error">{err}</div>}
          <button data-testid="reg-submit" className="primary-btn full span-2" disabled={busy || !phoneToken}>
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>

        <div className="auth-alt">
          <span>Already have an account?</span>
          <Link to="/login" data-testid="go-login">Sign in →</Link>
        </div>
      </div>
    </div>
  );
}
